import { boolean, mixedObj, object, constraints } from "./helpers";
import { DeviceSettingOptions } from "./settingOptions";
import { CallControl } from "./types";

export const call_control = object<CallControl>({
  second_incoming_call: object({
    value: mixedObj(
      DeviceSettingOptions.secondIncomingCallOpts,
      "SECOND_INCOMING_CALL"
    )
  }),
  computer_volume: object({
    value: mixedObj(DeviceSettingOptions.computerVolumeOpts, "COMPUTER_VOLUME")
  }),
  desk_phone_volume: object({
    value: mixedObj(
      DeviceSettingOptions.deskPhoneVolumeOpts,
      "DESK_PHONE_VOLUME"
    )
  }),
  mobile_phone_volume: object({
    value: mixedObj(
      DeviceSettingOptions.mobilePhoneVolumeOpts,
      "DESK_PHONE_VOLUME"
    )
  }),
  computer_ringtone: object({
    value: mixedObj(
      DeviceSettingOptions.computerRingtoneOpts,
      "COMPUTER_RINGTONE"
    )
  }),
  desk_phone_ringtone: object({
    value: mixedObj(
      DeviceSettingOptions.deskPhoneRingtoneOpts,
      "DESK_PHONE_RINGTONE"
    )
  }),
  mobile_phone_ringtone: object({
    value: mixedObj(
      DeviceSettingOptions.mobilePhoneRingtoneOpts,
      "DESK_PHONE_RINGTONE"
    )
  }),
  default_ringtone: object({
    value: boolean("RINGTONE"),
    constraints: constraints()
  }),
  auto_answer: object({
    value: boolean("AUTO_ANSWER"),
    constraints: constraints()
  }),
  smart_audio_transfer: object({
    value: boolean("SMART_AUDIO_TRANSFER"),
    constraints: constraints()
  }),
  call_button_lock: object({
    value: boolean("CALL_BUTTON_LOCK"),
    constraints: constraints()
  }),
  auto_mute: object({
    value: boolean("AUTO_MUTE"),
    constraints: constraints()
  }),
  active_call_audio: object({
    value: mixedObj(
      DeviceSettingOptions.activeCallAudioOpts,
      "ACTIVE_CALL_AUDIO"
    )
  }),
  auto_answer_cradle: object({
    value: boolean("AUTO_ANSWER_CRADLE"),
    constraints: constraints()
  }),
  auto_connect_mobile: object({
    value: boolean("AUTO_CONNECT_MOBILE"),
    constraints: constraints()
  }),
  auto_disconnect_cradle: object({
    value: boolean("AUTO_DISCONNECT_CRADLE"),
    constraints: constraints()
  }),
  default_phone_line: object({
    value: mixedObj(
      DeviceSettingOptions.defaultPhoneLineOpts,
      "DEFAULT_PHONE_LINE"
    )
  }),
  call_announcement: object({
    value: boolean("CALL_ANNOUNCEMENT"),
    constraints: constraints()
  }),
  mobile_voice_commands: object({
    value: boolean("MOBILE_VOICE_COMMANDS"),
    constraints: constraints()
  }),
  answer_voice_prompt: object({
    value: boolean("ANSWER_VOICE_PROMPT"),
    constraints: constraints()
  }),
  answering_call_alert: object({
    value: boolean("ANSWERING_CALL_ALERT"),
    constraints: constraints()
  }),
  mute_off_alert: object({
    value: mixedObj(DeviceSettingOptions.muteOffAlertOpts, "MUTE_OFF_ALERT")
  }),
  mute_reminder_timing: object({
    value: mixedObj(
      DeviceSettingOptions.muteReminderTimingOpts,
      "MUTE_REMINDER_TIMING"
    )
  }),
  mute_reminder_volume: object({
    value: mixedObj(
      DeviceSettingOptions.muteReminderVolumeOpts,
      "MUTE_REMINDER_VOLUME"
    )
  }),
  mute_alert_type: object({
    value: mixedObj(DeviceSettingOptions.muteAlertTypeOpts, "MUTE_ALERT_TYPES")
  }),
  audio_prompt_volume: object({
    value: mixedObj(
      DeviceSettingOptions.audioPromptVolumeOpts,
      "AUDIO_PROMPT_VOLUME"
    )
  }),
  caller_id: object({
    value: boolean("CALLER_ID"),
    constraints: constraints()
  }),
  audio_channel_tone: object({
    value: boolean("AUDIO_CHANNEL_TONE"),
    constraints: constraints()
  }),
  mute_reminder_mode: object({
    value: mixedObj(
      DeviceSettingOptions.muteReminderModeOpts,
      "MUTE_REMINDER_MODE"
    )
  }),
  mute_alerts: object({
    value: boolean("MUTE_ALERTS"),
    constraints: constraints()
  }),
  over_air_subscription: object({
    value: boolean("OVER_AIR_SUBSCRIPTION"),
    constraints: constraints()
  }),
  range: object({ value: boolean("RANGE"), constraints: constraints() }),
  computer_audio_bandwidth: object({
    value: mixedObj(
      DeviceSettingOptions.computerAudioBandwidthOpts,
      "COMPUTER_AUDIO_BANDWIDTH"
    )
  }),
  desk_phone_audio_bandwidth: object({
    value: mixedObj(
      DeviceSettingOptions.deskPhoneAudioBandwidthOpts,
      "DESK_PHONE_AUDIO_BANDWIDTH"
    )
  }),
  hd_voice: object({
    value: mixedObj(DeviceSettingOptions.hdVoiceOpts, "HD_VOICE")
  }),
  increase_qd_headset_volume: object({
    value: mixedObj(
      DeviceSettingOptions.increaseQdHeadsetVolumeOpts,
      "INCREASE_QD_HEADSET_VOLUME"
    )
  }),
  close_conversation_limiting: object({
    value: mixedObj(
      DeviceSettingOptions.closeConversationLimitingOpts,
      "CLOSE_CONVERSATION_LIMITING"
    )
  }),
  sidetone: object({
    value: mixedObj(DeviceSettingOptions.sidetoneOpts, "SIDETONE")
  }),
  notification_tones: object({
    value: boolean("NOTIFICATION_TONES"),
    constraints: constraints()
  }),
  ring_vibration: object({
    value: boolean("RING_VIBRATION"),
    constraints: constraints()
  }),
  online_indicator: object({
    value: boolean("ONLINE_INDICATOR"),
    constraints: constraints()
  }),
  wearing_preference: object({
    value: mixedObj(
      DeviceSettingOptions.wearingPreferenceOpts,
      "WEARING_PREFERENCE"
    )
  }),
  audio_sensing: object({
    value: boolean("AUDIO_SENSING"),
    constraints: constraints()
  }),
  dialtone: object({ value: boolean("DIALTONE"), constraints: constraints() }),
  rocket_button: object({
    value: mixedObj(DeviceSettingOptions.rocketButtonOpts, "ROCKET_BUTTON")
  })
}).required();
